import styled from '@emotion/styled';
import {
    colors,
    colorVariables,
    breakpoints,
    mediaQuery,
    boxSizes,
} from '@gumtree/ui-library/src/base/theme';

export const NewContactCardWrapper = styled.div`
    box-sizing: border-box;
    background: ${colorVariables.backgroundNeutral};

    ${mediaQuery.from(breakpoints.medium)} {
        border: 1px solid ${colors.newBorder};
        border-radius: ${boxSizes.borderRadius8};
        /* box-shadow: 0px 0px 12px 0px ${colors.black}; */
        box-shadow: 0px 0px 12px 0px #00000033;
    }
`;

export const PoweredLabelWrapper = styled.div<{ type: string, isMobile: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${props => props.type === 'vip' && props.isMobile ? 'flex-start' : 'center'};
`;
